const CAMPAIGNS_REQUEST = 'CAMPAIGNS_REQUEST';
const CAMPAIGNS_SUCCESS = 'CAMPAIGNS_SUCCESS';
const CAMPAIGNS_FAIL = 'CAMPAIGNS_FAIL';
const TBA_CAMPAIGNS_REQUEST = 'TBA_CAMPAIGNS_REQUEST';
const TBA_CAMPAIGNS_SUCCESS = 'TBA_CAMPAIGNS_SUCCESS';
const TBA_CAMPAIGNS_FAIL = 'TBA_CAMPAIGNS_FAIL';

const MY_CAMPAIGN_CREATE_REQUEST = 'MY_CAMPAIGN_CREATE_REQUEST';
const MY_CAMPAIGN_CREATE_SUCCESS = 'MY_CAMPAIGN_CREATE_SUCCESS';
const MY_CAMPAIGN_CREATE_FAIL = 'MY_CAMPAIGN_CREATE_FAIL';

const CAMPAIGN_DETAIL_REQUEST = 'CAMPAIGN_DETAIL_REQUEST';
const CAMPAIGN_DETAIL_SUCCESS = 'CAMPAIGN_DETAIL_SUCCESS';
const CAMPAIGN_DETAIL_FAIL = 'CAMPAIGN_DETAIL_FAIL';

const CAMPAIGN_REGISTER_ICO_REQUEST = 'CAMPAIGN_REGISTER_ICO_REQUEST';
const CAMPAIGN_REGISTER_ICO_SUCCESS = 'CAMPAIGN_REGISTER_ICO_SUCCESS';
const CAMPAIGN_REGISTER_ICO_FAIL = 'CAMPAIGN_REGISTER_ICO_FAIL';

const CAMPAIGN_AFFILIATE_CREATE_REQUEST = 'CAMPAIGN_AFFILIATE_CREATE_REQUEST';
const CAMPAIGN_AFFILIATE_CREATE_SUCCESS = 'CAMPAIGN_AFFILIATE_CREATE_SUCCESS';
const CAMPAIGN_AFFILIATE_CREATE_FAIL = 'CAMPAIGN_AFFILIATE_CREATE_FAIL';

const CAMPAIGN_ERC20_RATE_REQUEST = 'CAMPAIGN_ERC20_RATE_REQUEST';
const CAMPAIGN_ERC20_RATE_SUCCESS = 'CAMPAIGN_ERC20_RATE_SUCCESS';
const CAMPAIGN_ERC20_RATE_FAIL = 'CAMPAIGN_ERC20_RATE_FAIL';

const CAMPAIGN_LATEST_GET_REQUEST = 'CAMPAIGN_LATEST_GET_REQUEST ';
const CAMPAIGN_LATEST_GET_SUCCESS = 'CAMPAIGN_LATEST_GET_SUCCESS ';
const CAMPAIGN_LATEST_GET_FAIL = 'CAMPAIGN_LATEST_GET_FAIL ';

const CAMPAIGN_LATEST_ACTIVE_GET_REQUEST = 'CAMPAIGN_LATEST_ACTIVE_GET_REQUEST ';
const CAMPAIGN_LATEST_ACTIVE_GET_SUCCESS = 'CAMPAIGN_LATEST_ACTIVE_GET_SUCCESS ';
const CAMPAIGN_LATEST_ACTIVE_GET_FAIL = 'CAMPAIGN_LATEST_ACTIVE_GET_FAIL ';

const CAMPAIGN_EDIT_REQUEST = 'CAMPAIGN_EDIT_REQUEST';
const CAMPAIGN_EDIT_SUCCESS = 'CAMPAIGN_EDIT_SUCCESS';
const CAMPAIGN_EDIT_FAIL = 'CAMPAIGN_EDIT_FAIL';

const CAMPAIGN_STATUS_TOGGLE_REQUEST = 'CAMPAIGN_STATUS_TOGGLE_REQUEST';
const CAMPAIGN_STATUS_TOGGLE_SUCCESS = 'CAMPAIGN_STATUS_TOGGLE_SUCCESS';
const CAMPAIGN_STATUS_TOGGLE_FAIL = 'CAMPAIGN_STATUS_TOGGLE_FAIL';

const CAMPAIGN_TOKENS_REFUND_REQUEST = 'CAMPAIGN_TOKENS_REFUND_REQUEST';
const CAMPAIGN_TOKENS_REFUND_SUCCESS = 'CAMPAIGN_TOKENS_REFUND_SUCCESS';
const CAMPAIGN_TOKENS_REFUND_FAIL = 'CAMPAIGN_TOKENS_REFUND_FAIL';

const CAMPAIGN_DETAIL_HTTP_REQUEST = 'CAMPAIGN_DETAIL_HTTP_REQUEST';
const CAMPAIGN_DETAIL_HTTP_SUCCESS = 'CAMPAIGN_DETAIL_HTTP_SUCCESS';
const CAMPAIGN_DETAIL_HTTP_FAIL = 'CAMPAIGN_DETAIL_HTTP_FAIL';

export const campaignActions = {
  CAMPAIGNS_REQUEST,
  CAMPAIGNS_SUCCESS,
  CAMPAIGNS_FAIL,
  TBA_CAMPAIGNS_REQUEST,
  TBA_CAMPAIGNS_SUCCESS,
  TBA_CAMPAIGNS_FAIL,
  MY_CAMPAIGN_CREATE_SUCCESS,
  MY_CAMPAIGN_CREATE_REQUEST,
  MY_CAMPAIGN_CREATE_FAIL,
  CAMPAIGN_DETAIL_REQUEST,
  CAMPAIGN_DETAIL_SUCCESS,
  CAMPAIGN_DETAIL_FAIL,
  CAMPAIGN_REGISTER_ICO_REQUEST,
  CAMPAIGN_REGISTER_ICO_SUCCESS,
  CAMPAIGN_REGISTER_ICO_FAIL,
  CAMPAIGN_AFFILIATE_CREATE_REQUEST,
  CAMPAIGN_AFFILIATE_CREATE_SUCCESS,
  CAMPAIGN_AFFILIATE_CREATE_FAIL,
  CAMPAIGN_ERC20_RATE_REQUEST,
  CAMPAIGN_ERC20_RATE_SUCCESS,
  CAMPAIGN_ERC20_RATE_FAIL,
  CAMPAIGN_LATEST_GET_REQUEST,
  CAMPAIGN_LATEST_GET_SUCCESS,
  CAMPAIGN_LATEST_GET_FAIL,
  CAMPAIGN_LATEST_ACTIVE_GET_REQUEST,
  CAMPAIGN_LATEST_ACTIVE_GET_SUCCESS,
  CAMPAIGN_LATEST_ACTIVE_GET_FAIL,
  CAMPAIGN_EDIT_REQUEST,
  CAMPAIGN_EDIT_SUCCESS,
  CAMPAIGN_EDIT_FAIL,
  CAMPAIGN_STATUS_TOGGLE_REQUEST,
  CAMPAIGN_STATUS_TOGGLE_SUCCESS,
  CAMPAIGN_STATUS_TOGGLE_FAIL,
  CAMPAIGN_TOKENS_REFUND_REQUEST,
  CAMPAIGN_TOKENS_REFUND_SUCCESS,
  CAMPAIGN_TOKENS_REFUND_FAIL,
  CAMPAIGN_DETAIL_HTTP_REQUEST,
  CAMPAIGN_DETAIL_HTTP_SUCCESS,
  CAMPAIGN_DETAIL_HTTP_FAIL
};
